import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';
import { profileActionStatusAtom, profileErrorAtom } from 'Recoil/profile.atom';
import { AccountInfoForm, UploadProfileImage, AdditionalInfoForm, SuccessView, PersonalInfoForm } from 'Components/auth/register';
import { createProfile } from 'Services/profile.services';
import { find, isEmpty, isNil } from 'lodash';

import { Steps } from 'Components/base';

interface State {
  label: string | React.ReactNode;
  status: 'process' | 'wait' | 'success' | 'error';
}

import './register.scss';
import AddressInfoForm from 'Components/auth/register/address-info-form';
import { authRegisterUser } from 'Services/auth.services';

interface PractitionerRegistrationProps {
  accountType: 'BUSINESS_ACCOUNT' | 'INDIVIDUAL_ACCOUNT';
}

const PractitionerRegistration = ({ accountType }: PractitionerRegistrationProps) => {
  const { t } = useTranslation();
  const string = localStorage.getItem(process.env.INDIVIDUAL_REG_DRAFT);

  let [current, setCurrent] = useState(0);
  const [input, setInput] = useState<any>({ idType: 'NRIC' });

  const [status, setStatus] = useRecoilState<any>(profileActionStatusAtom);
  const [error, setError] = useRecoilState<any>(profileErrorAtom);

  const [steps, setSteps] = useState<State[]>([
    {
      label: "1",
      status: 'process'
    },
    {
      label: "2",
      status: 'process'
    },
    {
      label: "3",
      status: 'process'
    },
    // {
    //   label: "4",
    //   status: 'process'
    // },
    // {
    //   label: "5",
    //   status: 'process'
    // },
  ])

  useEffect(() => {
      // Remove draft on componentWillUnmount
      localStorage.removeItem(process.env.INDIVIDUAL_REG_DRAFT);
      setError({})
  }, [])

  useEffect(() => {
    if (string) {
      const localStorageData = string ? JSON.parse(string) : {};
      setInput({ ...input, ...localStorageData })
    }
  }, [string])

  useEffect(() => {
    if (isEmpty(error)) {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  }, [current])

  const next = (data: any) => {
    const currentInput = string ? JSON.parse(string) : {};
    localStorage.setItem(
      process.env.INDIVIDUAL_REG_DRAFT,
      JSON.stringify({ ...currentInput, ...data })
    );

    const currentStep = find(steps, (_, index) => { return index === current });

    if (currentStep) {
      currentStep!.status = 'success';
      steps.splice(current, 1, currentStep);
      setSteps(steps);
    }

    current++;
    setCurrent(current);
  };

  const prev = () => {
    const prevStep = find(steps, (_, index) => { return index === (current - 1) });

    if (prevStep) {
      prevStep!.status = 'process';
      steps.splice((current - 1), 1, prevStep);
      setSteps(steps);
    }

    current--;
    setCurrent(current);
  };

  const handleSubmit = async (data: any) => {
    const string = localStorage.getItem(process.env.INDIVIDUAL_REG_DRAFT);
    const input = string ? JSON.parse(string) : {};
    localStorage.setItem(
      process.env.INDIVIDUAL_REG_DRAFT,
      JSON.stringify({ ...input, ...data })
    );

    setStatus({ ...status, create: 'loading' });

    const responseData: any = accountType === 'BUSINESS_ACCOUNT' ?
      await authRegisterUser({ ...input, ...data }) :
      await createProfile({ ...input, ...data }, true);


    if (!isNil(responseData.error)) {
      setStatus({ ...status, create: 'error' });
      setError(responseData?.error);
    }
    else {
      setStatus({ ...status, create: 'success' });
      next(data);

      localStorage.removeItem(process.env.INDIVIDUAL_REG_DRAFT);
    }
  }

  const getPageTitle = () => {
    switch (accountType) {
      case 'BUSINESS_ACCOUNT':
        return t('title.signupForBusinessAccount')
      case 'INDIVIDUAL_ACCOUNT':
        return t('title.signupForIndividualAccount')
    }
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>Registration</title>
        <meta name="robots" content="noindex"/>
      </Helmet>
      <div className="registration-page">
        <div className="registration-page--main">
          <h1 className="registration-page--title my-20">
            {getPageTitle()}
          </h1>

          <Steps activeKey={current} steps={steps}>
            <div className="registration-page--form">
              {current === 0 &&
                <AccountInfoForm
                  accountType={accountType}
                  data={input}
                  onSubmit={next}
                />
              }

              {/* {current === 1 &&
                <UploadProfileImage
                  data={input}
                  onBack={prev}
                  onSubmit={next}
                />
              } */}

              {/* {current === 1 &&
                <PersonalInfoForm
                  data={input}
                  onBack={prev}
                  status={status.create}
                  onSubmit={next}
                />
              } */}

              {current === 1 &&
                <AddressInfoForm
                  accountType={accountType}
                  resError={error}
                  data={input}
                  status={status.create}
                  onBack={prev}
                  onSubmit={handleSubmit}
                />
              }

              {current === 2 && <SuccessView />}
            </div>
          </Steps>
        </div>
      </div>
    </React.Fragment>
  );
}

export default PractitionerRegistration;
